// AnnualTotalisersChart.js
import React from 'react';
import ReactApexChart from "react-apexcharts";

const AnnualTotalisersChart = ({ data }) => {
  // Prepare series based on the incoming data
  const series = [
    { 
      name: "Aggregate", 
      data: data?.Agg_Total || Array(12).fill(0) 
    },
    { 
      name: "Bitumen", 
      data: data?.Bit_Total || Array(12).fill(0) 
    },
    { 
      name: "Filler", 
      data: data?.Filler_Total || Array(12).fill(0) 
    },
    { 
      name: "Additive", 
      data: data?.Additive_Total || Array(12).fill(0) 
    },
    { 
      name: "RAP", 
      data: data?.RAP_Total || Array(12).fill(0) 
    },
    { 
      name: "Gas", 
      data: data?.Gas_Total || Array(12).fill(0) 
    },
    { 
      name: "Fuel", 
      data: data?.Fuel_Total || Array(12).fill(0) 
    },
    { 
      name: "Electricity", 
      data: data?.Electric_Total || Array(12).fill(0) 
    }
  ];

  // Chart options with shaded areas
  const options = {
    chart: {
      toolbar: { 
        show: false 
      },
    },
    tooltip: {
      enabled: true,
      theme: "dark",
      style: {
        fontSize: '12px'
      },
      y: {
        formatter: function(value) {
          return value.toFixed(0);
        }
      }
    },
    dataLabels: { 
      enabled: false 
    },
    stroke: { 
      curve: "smooth",
      width: 2
    },
    xaxis: {
      type: "category",
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ],
      labels: {
        style: { 
          colors: "#c8cfca", 
          fontSize: "10px" 
        },
      },
      axisBorder: { 
        show: false 
      },
      axisTicks: { 
        show: false 
      },
    },
    yaxis: {
      labels: {
        style: { 
          colors: "#c8cfca", 
          fontSize: "10px" 
        },
        formatter: function (value) {
          return Number.isInteger(value) ? value : "";
        },
      },
    },
    legend: { 
      show: false,
      position: 'top',
      horizontalAlign: 'left',
      labels: {
        colors: '#c8cfca',
        useSeriesColors: false
      }
    },
    grid: {
      strokeDashArray: 5,
      borderColor: "#56577A",
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "vertical",
        shadeIntensity: 0,
        gradientToColors: undefined,
        inverseColors: true,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 100]
      }
    },
    markers: {
      size: 0
    },
    colors: [
      "#14B8A6", "#3B82F6", "#6366F1", 
      "#EC4899", "#F59E0B", "#FACC15",
      "#0075FF", "#2CD9FF"
    ],
  };

  return (
    <div style={{ height: '100%' }}>
      <ReactApexChart 
        options={options} 
        series={series} 
        type="area"  // Changed from "line" to "area" for shaded regions
        height={350} 
      />
    </div>
  );
};

export default AnnualTotalisersChart;